import React, { useContext, useEffect, useState } from 'react';

import CourtsContent from './CourtsContent';
import FireDataContext from '../../../services/firebase/FireDataContext';
import MemberMiniMenu from '../../members/menus/MemberMiniMenu';

const CourtsPage = () => {
    const db = useContext(FireDataContext);
    const [courts, setCourts] = useState();

    useEffect(() => {
        (async () => {
            const buffer = new Map();

            const members = await db.get({ path: `intermediaries`, context: `CourtsPage` });
            const results = await Promise.all(
                members.map(({ id }) => {
                    return db.get({
                        path: `intermediaries/${id}/quotes`,
                        query: {
                            field: 'court.costCentre',
                            operator: '>=',
                            value: '0'
                        },
                        context: 'CourtsPage'
                    })
                }
                ));

            console.log('results', results)

            results.forEach(quotes => {
                quotes.forEach(({ court: { costCentre = '', name = '' } = {} }) => {
                    if (!buffer.has(costCentre)) {
                        buffer.set(costCentre, { costCentre, name });
                    }
                });
            });


            setCourts(Array.from(buffer.values()));
        })();
    }, [db]);

    return (
        <MemberMiniMenu>
            <CourtsContent courts={courts} />
        </MemberMiniMenu>
    );
};

export default CourtsPage;